.container {
    max-width: 900px;
    margin: 0 auto;
    padding: 16px 32px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 12px;
}

.toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 10px 12px;
    background: #f8f9fa;
    border-radius: 4px;
    margin-bottom: 16px;
    flex-wrap: wrap;
}

.toolbar-left,
.toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;
}

.refresh-button {
    padding: 5px 12px;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-size: 11px;
    background: #6c757d;
}

.refresh-button:hover {
    background: #5a6268;
}

.loading,
.error {
    padding: 32px;
    text-align: center;
    color: #6c757d;
}

.error {
    color: #dc3545;
}
